// Librerías
import React from 'react';
import { Helmet } from 'react-helmet';
// Componentes
import FAQC from '../components/FAQ/FAQComponent';
import Footer from '../components/Footer/Footer';
import Navbar from '../components/Navbar/Navbar';

const FAQ = () => {
  return(
    <div>
        <Helmet>
          <title>Centro de Ayuda | Alohar</title>
          <meta
            name="description"
            content="Resuelve dudas sobre reservas, pagos, cancelaciones y uso de Alohar en nuestro centro de ayuda."
          />
          <link rel="canonical" href="https://alohar.me/ayuda" />
        </Helmet>
        <Navbar addSearch={false} hideAlohadorButtons={true} hideSearchButtons={true}/>
        <FAQC />
        <Footer />
    </div>
  );
}

export default FAQ;